import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

import OrderTable from '../components/OrderTable'
import OrderPrice from '../components/OrderPrice'

const Preview = (props) => {
  let { formControls, product, targetPrice } = props

  return (
    <div className="c-personalizer-preview js-personalizer-preview">

      { product.id ? (
        <div className="c-personalizer-preview__container">
            
          { product.image ? (
            <div className="c-personalizer-preview__image u-image" dangerouslySetInnerHTML={{ __html: product.image }} />
          ) : null }

          <p className="c-personalizer-row__title">Overzicht</p>
          <OrderTable formControls={formControls} />

          <OrderPrice targetPrice={targetPrice} />
        </div>
      ) : null }

    </div>
  )
}

export default Preview



// WEBPACK FOOTER //
// ./src/js/personalizer/components/Preview.js